module.exports = __webpack_public_path__ + "static/media/upload_headers_popup_required_data.3bbbb995.png";